function getCookieDomain() {
  const { hostname } = location;
  const domains = [
    {
      domain: 'kr-dv-midasitwebsol.com',
      cookieDomain: '.kr-dv-midasitwebsol.com',
    },
    { domain: 'recruiter.co.kr', cookieDomain: '.recruiter.co.kr' },
    { domain: 'recruitment.kr', cookieDomain: '.recruitment.kr' },
    { domain: 'midasweb.net', cookieDomain: '.midasweb.net' },
    {
      domain: 'gov-st-midasitwebsol.com',
      cookieDomain: '.gov-st-midasitwebsol.com',
    },
  ];

  const matchedDomain = domains.find((item) => hostname.includes(item.domain));

  return matchedDomain ? matchedDomain.cookieDomain : '';
}

function deleteAllCookies() {
  const pastDate = new Date(1970, 0, 1).toUTCString();
  const cookies = document.cookie.split(';');
  cookies.forEach((cookie) => {
    const trimmedCookie = cookie.trim();
    const [name] = trimmedCookie.split('=');
    document.cookie = `${name}=; expires=${pastDate}; path=/`;
  });
}

window.addEventListener('beforeunload', () => {
  const pagePathType = location.pathname.split('/')[1];
  if (location.href.includes('login')) {
    const cookieValue = `true/${pagePathType}; DOMAIN=${getCookieDomain()}; PATH=/`;
    D.cookie.fn.set('isLoginPopstateStatus', cookieValue);
  } else {
    const cookieValue = `false/${pagePathType}; DOMAIN=${getCookieDomain()}; PATH=/`;
    D.cookie.fn.set('isLoginPopstateStatus', cookieValue);
  }
});
window.addEventListener('pageshow', (e) => {
  const match = document.cookie.match(
    '(^|;) ?isLoginPopstateStatus=([^;]*)(;|$)',
  );
  const isLoginPopstateStatus = match ? match[2].split('/') : 'false';
  if (
    e.persisted &&
    isLoginPopstateStatus[0] === 'true' &&
    !location.href.includes('/login')
  ) {
    // deleteAllCookies();
    location.href = `/${isLoginPopstateStatus[1]}/login`;
  }
});
